import {
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_POSTS,
  LOADING_POSTDIALOG,
  LOADING_PROFILE,
  LOADING_NEWPOST,
  LOADING_CREDENTIALS,
  STOP_LOADING_POSTS,
  STOP_LOADING_POSTDIALOG,
  STOP_LOADING_PROFILE,
  STOP_LOADING_NEWPOST,
  STOP_LOADING_CREDENTIALS,
} from "../types";

const initialState = {
  //loading: false,
  loadingPosts: false,
  loadingPostDialog: false,
  loadingProfile: false,
  loadingNewPost: false,
  loadingCredentials: false,
  errors: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ERRORS:
      return {
        ...state,
        loadingPosts: false,
        loadingPostDialog: false,
        loadingProfile: false,
        loadingNewPost: false,
        loadingCredentials: false,
        errors: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        loadingPosts: false,
        loadingPostDialog: false,
        loadingProfile: false,
        loadingNewPost: false,
        loadingCredentials: false,
        errors: null,
      };
    case LOADING_POSTS:
      return {
        ...state,
        loadingPosts: true,
      };
      case LOADING_PROFILE:
      return {
        ...state,
        loadingProfile: true,
      };
      case LOADING_POSTDIALOG:
      return {
        ...state,
        loadingPostDialog: true,
      };
      case LOADING_NEWPOST:
      return {
        ...state,
        loadingNewPost: true,
      };
      case LOADING_CREDENTIALS:
      return {
        ...state,
        loadingCredentials: true,
      };
      case STOP_LOADING_POSTS:
        return {
          ...state,
          loadingPosts: false,
        };
        case STOP_LOADING_PROFILE:
        return {
          ...state,
          loadingProfile: false,
        };
        case STOP_LOADING_POSTDIALOG:
        return {
          ...state,
          loadingPostDialog: false,
        };
        case STOP_LOADING_NEWPOST:
        return {
          ...state,
          loadingNewPost: false,
        };
        case STOP_LOADING_CREDENTIALS:
        return {
          ...state,
          loadingCredentials: false,
        };
    default:
      return state;
  }
}
